import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import './style.css'
import Home from './views/home'
import LoginPage from './views/login-page'
import StorePage from './views/store-page'
import Pending from './views/pending'
import ChatPage from './views/chat-page'
import ProfilePage from './views/profile-page'
import NotFound from './404'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={LoginPage} exact path="/account" />
        <Route component={StorePage} exact path="/store" />
        <Route component={Pending} exact path="/pending" />
        <Route component={ChatPage} exact path="/chat" />
        <Route component={ProfilePage} exact path="/profile" />
        <Route path={'*'} component={NotFound} />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
